import React from 'react'
import _cx from 'classnames/bind'
import type { OnlineAuctionSegmentBidType } from '@adc/sdk/types'
import type { FeatureFlags } from '@adc/ui-adc'
import {
  type AuctionBlueprintScheduledOnlineReactiveArgs,
  type primitives,
} from '@adc/blueprint'
import * as graph from '@adc/sdk'
import { formatMoneyWithNumeral } from 'common/utils/formatters'
import { ZERO_DOLLARS } from 'common/components/bidBanner/constants'
import { MaxBidTooltip } from 'common/components/bidBanner/tooltips'
import BidButton from '../bidButton'
import cls from './styles.scss'
const cx = _cx.bind(cls)

type AuctionUser = primitives.AuctionUser

export const getWarningMessage = (
  segment: AuctionBlueprintScheduledOnlineReactiveArgs['segment']
) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const nextMaxBidAmount = segment.__methods__.getNextMaxBidAmount()
  const minimumNextBid = formatMoneyWithNumeral(
    nextMaxBidAmount,
    ZERO_DOLLARS
  ) as string
  return `Bid amount must be at least ${minimumNextBid}.`
}

interface ProxyBidFormUIProps {
  bidAmount: number
  handleBidButtonClick: (callback: void) => void
  hasError: boolean
  isPerformingBid: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  setBiddingMode: (mode: OnlineAuctionSegmentBidType) => void
  biddingMode: OnlineAuctionSegmentBidType
  performBid: () => void
  warning: boolean
  user: AuctionUser
  isMaxBiddingActive: boolean
  isUserConfirmed: boolean
  segment: AuctionBlueprintScheduledOnlineReactiveArgs['segment']
  cleanUp: () => void
  featureFlags: FeatureFlags
  setIsAdjustMode: (value: boolean) => void
}

const ProxyBidFormUI = (props: ProxyBidFormUIProps) => {
  const {
    bidAmount,
    handleBidButtonClick,
    hasError,
    isPerformingBid,
    onChange,
    setBiddingMode,
    performBid,
    user,
    isMaxBiddingActive,
    isUserConfirmed,
    cleanUp,
    featureFlags,
    setIsAdjustMode,
  } = props

  return (
    <div>
      <div className={cx('u-mb-6')}>
        <BidButton
          isMaxBiddingActive={isMaxBiddingActive}
          isUserConfirmed={isUserConfirmed}
          bidAmount={bidAmount}
          hasError={hasError}
          handleBidButtonClick={handleBidButtonClick}
          isPerformingBid={isPerformingBid}
          performBid={performBid}
          biddingMode={graph.enums.OnlineAuctionSegmentBidType.MaxBid}
          setBiddingMode={setBiddingMode}
          onChange={onChange}
          user={user}
          cleanUp={cleanUp}
          featureFlags={featureFlags}
          setIsAdjustMode={setIsAdjustMode}
        />
      </div>
      <div className={cx('centered-section')}>
        {isMaxBiddingActive && <MaxBidTooltip />}
      </div>
    </div>
  )
}

export default ProxyBidFormUI
